import fp from 'lodash/fp';
import queryString from 'query-string';

export const searchToFilters = (search, filterDefinitions, defaultFilters) => {
    if (search) {
        const searchString = fp.flow(
            queryString.parse,
            fp.get('filters')
        )(search);

        if (!searchString) { return defaultFilters; }

        const givenValues = fp.flow(
            decodeURIComponent,
            atob,
            JSON.parse,
            fp.entries
        )(searchString);

        const filterValues = fp.flow(
            fp.filter(([filterId]) => fp.find(
                definition => filterId === definition.id
            )(filterDefinitions)),
            fp.map(([filterId, filterValue]) => ({
                id: filterId,
                value: filterValue
            }))
        )(givenValues);

        const newFilters = fp.map(definition => (
            {
                definition,
                value: fp.flow(
                    fp.find(newValue => newValue.id === definition.id),
                    value => (value ? value.value : undefined)
                )(filterValues)
            }))(filterDefinitions);
        return newFilters;
    }

    return defaultFilters;
};

export const filtersToSearch = (filters) => {
    const filtersToUse = fp.filter(filter => filter.value !== undefined)(filters);

    if (!filtersToUse.length) { return ''; }

    const search = fp.flow(
        fp.filter(filter => filter.value !== undefined),
        fp.reduce((acc, cur) => ({ ...acc, [cur.definition.id]: cur.value }), {}),
        JSON.stringify,
        btoa,
        encodeURIComponent
    )(filtersToUse);

    return `filters=${search}`;
};

const isSortingObject = obj => obj.gridSort
    && obj.gridSort.length
    && Array.isArray(obj.gridSort)
    && obj.gridSort.every(
        x => x.desc === true || x.desc === false
    );

export const urlToSort = (search) => {
    if (search) {
        const searchString = fp.flow(
            queryString.parse,
            fp.get('sorting')
        )(search);

        if (!searchString) { return []; }

        return fp.flow(
            decodeURIComponent,
            atob,
            JSON.parse,
            fp.filter(isSortingObject)
        )(searchString);
    }
    return [];
};

export const encodeSortingIntoUrl = (sorting) => {
    if (!sorting || !sorting.length) { return ''; }

    const generatedString = fp.flow(
        JSON.stringify,
        btoa,
        encodeURIComponent
    )(sorting);

    return `sorting=${generatedString}`;
};
